export default [
  {
    leistungstext: "Feuer, Sturm/Hagel und Leitungswasser",
    infoText:
      "Versicherungsschutz besteht, wenn das Gebäude durch eine der genannten Gefahren zerstört oder beschädig wird.",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Grob fahrlässige Obliegenheitsverletzung bei",
    infoText: "Kein Einwand der groben Fahrlässigkeit bei Verletzung von Obliegenheiten/Sicherheitsvorschriften",
    leistungen: ["Nein", "Schäden bis 5.000 €", "Schäden bis 50.000 €"],
  },
  {
    leistungstext: "Nebengebäude bis 40m²",
    infoText:
      "Zu Nebengebäuden gehören alle Bauwerke, die keine Garagen oder Carports sind. Garagen und Carports sind unbegrenzt mitversichert, wenn diese angegeben werden.",
    leistungen: ["1.000 €", "15.000 €", "Ja"],
  },
  {
    leistungstext: "Mietverlust für Wohnraum",
    infoText:
      "Erstattung des Mietausfalls, wenn Mieter von Wohnräumen in Folge eines Versicherungsfalles die Zahlung der Miete ganz oder teilweise einstellen.",
    leistungen: ["12 Monate", "24 Monate", "36 Monate"],
  },
  {
    leistungstext: "Leckortungskosten bei nicht versicherten Schäden",
    infoText:
      "Der Versicherer ersetzt auch bei nicht versicherten Leitungswasserschäden die Kosten zur Leckortung durch eine Fachfirma.",
    leistungen: ["Nein", "500 €", "Ja"],
  },
  {
    leistungstext: "Wiederaufbau an einem anderen Ort nach Totalschaden innerhalb Deutschlands",
    infoText:
      "Nach einem Totalschaden kann der Versicherungsnehmer auch an einem neuen Risikoort das Gebäude zum Neuwert wiederaufbauen.",
    leistungen: ["Nein", "Nein", "Ja"],
  },
  {
    leistungstext: "Grobe Fahrlässigkeit (Herbeiführung des Versicherungsfalls)",
    infoText: "Es findet keine Kürzung der Leistung aufgrund grober Fahrlässigkeit statt.",
    leistungen: ["Schäden bis 1.000 €", "Ja", "Ja"],
  },
  {
    leistungstext: "Gebäudebeschädigung nach Einbruch, Graffitischäden und böswillige Beschädigung",
    infoText:
      "Gebäudeschäden infolge eines Einbruchs oder Einbruchversuchs, durch Graffiti oder sonstige böswillige Handlungen werden übernommen. Dies umfasst auch Glasscheiben, sofern es keine Schaufensterscheiben sind.",
    leistungen: ["Nein", "10.000 €", "Ja"],
  },
  {
    leistungstext: "Wasserzuleitungsrohre außerhalb des Grundstückes",
    infoText:
      "Leistungen für frostbedingte oder sonstige Bruchschäden an Wasserzuleitungsrohren auch außerhalb Ihres Grundstückes.",
    leistungen: ["Nein", "Ja", "Ja"],
  },
  {
    leistungstext: "Ableitungsrohre außerhalb des Gebäudes sowie außerhalb des Grundstückes",
    infoText:
      "Kostenübernahme für frostbedingte oder sonstige Bruchschäden an Ableitungsrohren der Wasserversorgung, auch wenn sie außerhalb des versicherten Grundstücks verlaufen und das beschädigte Rohr der Entsorgung Ihres Gebäudes dient.",
    leistungen: ["Nein", "20.000 € / 10.000 € ohne Dichtheitsprüfung", "20.000 € ohne Dichtheitsprüfung"],
  },
  {
    leistungstext: "Rohrverstopfungen",
    infoText: "Mitversichert sind die Kosten, die anfallen, um Verstopfungen von Ableitungsrohren zu beseitigen.",
    leistungen: ["Nein", "1.000 €", "Ja"],
  },
  {
    leistungstext: "Beseitigung umgestürzter oder abgeknickter Bäume",
    infoText:
      "Kosten für das Aufräumen und Entfernen von Bäumen, die durch Sturm oder Blitzeinschlag abgeknickt bzw. umgestürzt sind.",
    leistungen: ["Nein", "10.000 €", "Ja"],
  },
  {
    leistungstext: "Summen- und Bedingungsdifferenzdeckung (bis 15 Monate)",
    infoText:
      "Versicherungsschutz im beantragten Umfang besteht bereits ab Antragstellung auch vor dem Versicherungsbeginn für max. 15 Monate, sofern über den Vorvertrag keine komplette Entschädigungsleistung erbracht wird.",
    leistungen: ["Nein", "Nein", "Ja"],
  },
  {
    leistungstext: "Besitzstandsgarantie",
    infoText:
      "Wir garantieren, dass unsere Kunden im Schadenfall nicht schlechter gestellt werden können, als es im direkten Vorvertrag der Fall gewesen wäre.",
    leistungen: ["Nein", "Nein", "Ja"],
  },
  {
    leistungstext: "Unbenannte Gefahren bis 200.000 €, mit SB 10 % des Schadens, mind. 500 €, max. 5.000 €",
    infoText:
      "Ergänzend zu den bekannten Gefahren leisten wir auch Entschädigung bei Zerstörung und Beschädigung durch unbekannte und unvorhersehbare Gefahren.",
    leistungen: ["Nein", "Nein", "Ja"],
  },
  {
    leistungstext: "Best-Leistungs-Garantie bis 200.000 € mit SB 250 €",
    infoText:
      "Bietet ein anderes Versicherungsunternehmen weitgehenderen Versicherungsschutz als wir, erweitern wir unseren unter bestimmten Voraussetzungen dementsprechend.",
    leistungen: ["Nein", "Nein", "Ja"],
    photovoltaikErtragsausfallPruefen: true,
  },
];
